<template>
  <div id="app" class="oo-module" :style="getStyle()">
    <component :is="layout">
      <router-view />
    </component>
    <transition name="fade">
      <progress-indicator v-show="!storeLoaded && !isMobile()" />
    </transition>
  </div>
</template>

<script>
const default_layout = "full";
import { mapGetters, mapMutations, mapActions } from "vuex";
import ProgressIndicator from "./components/progressindicator";
export default {
  components: {
    ProgressIndicator
  },
  created() {
    this.setStoreLoading();
    this.initHQDoc();
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
    ...mapGetters(["storeLoaded", "desktopStyles"])
  },
  methods: {
    ...mapMutations(["setStoreLoading"]),
    ...mapActions(["initHQDoc"]),
    getStyle() {
      var style = [];
      if (!this.isMobile()) {
        style.push(this.desktopStyles.primaryBodyBackground);
      }
      return style;
    }
  }
};
</script>
